<template>
  <section class="threads-card">
    <div class="threads-layout">
      <div class="threads-logo">
        <a :href="threadsUrl" aria-label="Go to Goalbook Threads">
          <img
            alt="Threads logo"
            src="@/assets/Threads_1.svg"
            class="logo-img">
        </a>
      </div>
      <div class="threads-content">
        <p class="threads-description">
          <a :href="threadsUrl">Draft a research-based, individualized IEP from start to finish using AI.</a>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { goalbookUrls } from '@/links'

export default {
    name: 'ThreadsCardLink',
    computed: {
        threadsUrl() {
            return goalbookUrls.threads
        }
    }
}
</script>

<style lang="less" scoped>
@import '~@/variables.less';

.threads-card {
  border: 2px solid #BDBDBD;
}

.threads-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 20px;
}

.threads-logo {
  flex-shrink: 0;
}

.logo-img {
  height: 28px;
  width: auto;
}

.threads-content {
  flex: 1;
  max-width: 400px;
}

.threads-description {
  margin: 0;
  font-size: 1rem;
  line-height: 1.4;
}

@media (max-width: @screen-md) {
  .logo-img {
    height: 26px;
  }
}

@media (max-width: @screen-sm) {
  .threads-layout {
    padding: 14px 16px;
    gap: 16px;
  }

  .logo-img {
    height: 24px;
  }
}
</style>
